export class EventRequestTotals {
 
  statistic: string;
  total: number;
}



// WEBPACK FOOTER //
// ./src/app/core/models/event-request-totals.ts